import AbstractObserver from '../../../../js/utils/abstract-observer.js';
import { UpdateType } from '../../../../js/utils/const';

export class PortfolioModel extends AbstractObserver {
  constructor() {
    super();

    this._data = {};
  }

  async loadData(id) {
    try {
      if (!this._data[id]) {
        const response = await fetch(`/landgen/api/v1/portfolio/${id}`);
        const { data } = await response.json();
        this._data[id] = data;
      }

      this._notify(UpdateType.INIT);
    } catch (e) {
      window.Sentry.captureException(`Не удалось загрузить портфолио: ${e}`);
      this._notify(UpdateType.ERROR);
    }
  }

  getPortfolio(id) {
    return this._data[id];
  }
}
